<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="mttrsnap">
          <div class="content-panel1" v-show="IsMttrErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ widgetControl }}</h2>
            <apiErrorComponent @tryReload="tryReload" :compTitle="widgetControl" compId="mttrsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IsMttrErr" :class="{ 'contblinking': iskeyMTTR }">
            <div class="insideL  hide-on-presentation " :class="isHovered ? 'showL' : ''">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsMttrErr">
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" v-show="myBubbleShow"
                    title="Switch to Alternate View" v-on:click="swapCharts()" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" v-show="myBubbleShow" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                  <span class="myLeftHover" v-on:mouseenter="isHovered = true" v-show="funcCrt.length">
                    <font-awesome-icon icon="fa-solid fa-magnifying-glass-chart" title="Explain Trend" />
                  </span>
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.mttrinfo }} You can click on individual underlined text/bubbles to get more
                insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li v-if="myBubbleShow">Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to
                    swap between trend and bubble chart view
                  </li>
                  <li v-if="myBubbleShow">Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with
                    values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download
                    all the
                    insights
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-magnifying-glass-chart" /> explain the trends
                    (where applicable)
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadmttr">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div class="infoLeftHover" v-show="isHovered" v-on:mouseleave="isHovered = false">
              <div v-for="(value, index) in funcCrt" :key="index" class="cursor-pointer">
                <span v-on:click="explainModel(value)">{{ value.split('~')[1] }}</span>
              </div>
            </div>
            <div v-if="isLoadmttr"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ widgetControl }}</h2>
            <div class="panel-body" :class="{ 'BlurClass': !isLoadmttr }">
              <div v-if="!myBubbleShow">
                <section class="tblSection" v-if="shwMttr && !IsMttrErr">
                  <table class="table-striped Striped-font thmHead mttrTbl">
                    <tr class="themeclr2 row" v-if="isslaadherence">
                      <th class="text-center col-3">
                        Request Priority
                      </th>
                      <th class="text-center col-3">
                        SLA Adhereance
                      </th>
                      <th class="text-center col-4">
                        MTTR
                      </th>
                      <th class="text-center col-2">
                        # Tickets
                      </th>
                    </tr>
                    <tr class="themeclr2 row" v-if="!isslaadherence">
                      <th class="text-center col-4">
                        Request Priority
                      </th>
                      <th class="text-center col-5">
                        MTTR
                      </th>
                      <th class="text-center col-3">
                        # Tickets
                      </th>
                    </tr>
                    <tbody v-for="(dataV, index) in mttrdata" v-bind:key="dataV">
                      <tr class="row" v-if="isslaadherence">
                        <td v-on:click="onTickets(dataV.Request_Priority)" class="col-3">
                          <span class="uSpl">{{ dataV.Request_Priority }}</span>
                        </td>
                        <td class="text-start col-3 d-flex">
                          <div style="width:50%">{{ dataV.slaadherence.toFixed(1) }}
                            <small>%</small>
                          </div>
                          <div style="height: 25px; display: inline-block;margin-left: 5px;width:50%;"
                            :id="'MTTXA' + index">
                          </div>
                        </td>
                        <td class="text-start col-4 d-flex">
                          <div style="width:50%">{{ convert2ddhhmm(dataV.Mttr, 'M') }}</div>
                          <div style="height: 25px; display: inline-block;margin-left: 5px;width:50%;"
                            :id="'MTTXV' + index">
                          </div>
                        </td>
                        <td class="text-end col-2">
                          {{ dataV.PriorityCount.toLocaleString() }}
                        </td>
                      </tr>
                      <tr class="row" v-if="!isslaadherence">
                        <td v-on:click="onTickets(dataV.Request_Priority)" class="col-4">
                          <span class="uSpl">{{ dataV.Request_Priority }}</span>
                        </td>
                        <td class="text-start col-5 d-flex">
                          <div style="width:50%">{{ convert2ddhhmm(dataV.Mttr, 'M') }}</div>
                          <div style="height: 25px; display: inline-block;margin-left: 5px;width:50%"
                            :id="'MTTXV' + index">
                          </div>
                        </td>
                        <td class="text-end col-3">
                          {{ dataV.PriorityCount.toLocaleString() }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </section>
                <div v-if="!shwMttr">
                  <table class="table-striped Striped-font thmHead mttrTbl1">
                    <tbody>
                      <tr class="themeclr2 row">
                        <th class="text-center col-3">
                          Request Priority
                        </th>
                        <th v-if="isslaadherence" class="text-center col-3">
                          SLA Adhereance
                        </th>
                        <th class="text-center col-4">
                          {{ tbl_mttr }}
                        </th>
                        <th class="text-center col-2">
                          # Tickets
                        </th>
                      </tr>
                      <tr v-for="(dataV, index) in mttrdata" v-bind:key="dataV" class="row">
                        <td v-on:click="onTickets(dataV.Request_Priority)" class="col-3">
                          <span class="uSpl">{{ dataV.Request_Priority }}</span>
                        </td>
                        <td class="text-start col-3 d-flex" v-if="isslaadherence">
                          <div style="width: 50%;"> {{ dataV.slaadherence.toFixed(1) }}
                            <small>%</small>
                          </div>
                          <div style="height: 25px;display: inline-block;margin-left: 5px;width: 50%;"
                            :id="'MTTXA' + index">
                          </div>
                        </td>
                        <td class="text-start col-4 d-flex">
                          <div style="width: 50%;"> {{ convert2ddhhmm(dataV.Mttr, 'M') }}</div>
                          <div style="height: 25px;display: inline-block;margin-left: 5px;width: 50%;"
                            :id="'MTTXV' + index">
                          </div>
                        </td>
                        <td class="text-end col-2">
                          {{ dataV.PriorityCount.toLocaleString() }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="chartHeightControlMTTR">
                    <div id="mttrTrend"> </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div :class="isMinimize ? 'col-6' : 'col-12'">
                    <div class="chartHeightControl" style="margin-top:-10px">
                      <div id="mttrBC"></div>
                    </div>
                  </div>
                </div>
                <div v-if="isShowTable">
                  <div v-on:click="onBtnExport()" class="myfaBtn spl">
                    <font-awesome-icon :icon="['fas', 'fa-download']" />
                  </div>
                  <ag-grid-vue style="width: 96%;height:470px;"
                    class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="mttrcolsDefs"
                    @grid-ready="onReMttr" :modules="modules" :enableBrowserTooltips="true">
                  </ag-grid-vue>
                </div>
                <div v-if="IsMttrdata" class="widgetError text-center">
                  <widgetDataMsg></widgetDataMsg>
                </div>
              </div>
            </div>
            <widgetsSlider :insideArr="mttrinsight" :isInsErr="IsMTInsErr" :isErr="IsMttrErr" :compTitle="widgetControl"
              compId="mttrsnap"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  reactive,
  ref
} from "vue";
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import Sparkline from 'sparklines';
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import widgetExplainData from "./../../mixin/wiExplainLink";
import apiErrorComponent from '../smallcomp/apierror.vue'
import widgetsSlider from '../smallcomp/widgets-slider.vue';
var mttrwholedata
var myMTTChart
function reportWindowSizeMTT() {
  if (myMTTChart != undefined) {
    myMTTChart.resize()
  }
}
function convert2ddhhmm(minutesValue, suffix) {
  if (suffix != "") {
    if (suffix.toUpperCase() == "H") {
      minutesValue = minutesValue * 60;
    } else if (suffix.toUpperCase() == "D") {
      minutesValue = minutesValue * 60 * 8;
    }
    var hours = Math.floor(minutesValue / 60);
    var minutes = Math.round((minutesValue % 60), 2);
    var days = 0;
    if (hours > 24) {
      days = Math.floor(hours / 24);
      hours = Math.floor(hours % 24);
    }
    var returnVal = '';
    if (days != 0) {
      returnVal += days + 'd ';
    }
    if (hours != 0) {
      returnVal += hours + 'h ';
    }
    if (minutes != 0) {
      returnVal += minutes + 'm ';
    }
  } else {
    returnVal = minutesValue;
  }
  if (returnVal == 0) {
    returnVal = '-'
  }
  return returnVal;
}
export default {
  name: 'MTTRView',
  mixins: [screenShotMix, widgetExplainData],
  props: {
    getPins: Object,
    tabname: String,
  },
  components: {
    widgetDataMsg,
    widgetLoadingComp,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      IsInsightMttr: false,
      IsMttrdata: false,
      isLoadmttr: false,
      isMttrTrend: false,
      IsMttrErr: false,
      isslaadherence: false,
      IsMTInsErr: false,
      widgetControl: "",
      shwMttr: false,
      isMTTRTablelLoaded: false,
      isShowTable: false,
      myBubbleShow: null,
      showBubbleTbl: false,
      iskeyMTTR: false,
      isMinimize: false,
      mttrinsight: [],
      mttrAllApi: null,
      mttrPriorApi: null,
      mttrReApi: null,
      columnApi: null,
      mttrdata: {},
      mttrPriordata: null,
      mttrRedata: null,
      tbl_mttr: "",
      myColorArray: [],
      myBorderArray: [],
      mttrcolsDefs: reactive([]),
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      isChartRedraw: true,
      isdrawTrend: false,
      funcCrt: [],
      spCurveStyles2: {
        stroke: '#567c8a'
      },
      isHovered: false,
    }
  },
  methods: {
    explainModel(currpass) {
      var emit = this.$emit
      emit("explainModel", currpass)
    },
    genrateExplainLink() {
      this.funcCrt = []
      this.funcCrt = this.widgetExplain(this.mttrinsight)
    },
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getMTTR(this.getwgtCond)
    },
    addToSlider() {
      let insArr = this.mttrinsight;
      this.isHovered = false
      let name = this.widgetControl + " - " + this.getPins.viewName;
      let screenShort = {
        id: 'mttrsnap',
        name: 'mttrsnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.isShowTable = true;
      }
    },
    onBtnExport() {
      this.mttrReApi.exportDataAsCsv();
    },
    downloadDom() {
      let removeSpaceName = this.widgetControl.replace(/ /g, "_");
      let imgname = removeSpaceName + ".png"
      this.isHovered = false
      let widgetID = "mttrsnap"
      var geticondiv = document.querySelectorAll('#mttrsnap .insideL,#mttrsnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let insArr = []
      if (this.shwMttr == true) {
        insArr = this.mttrinsight.join("\r\n")
      } else {
        var pushTrdIns = []
        for (var i = 0; i < mttrwholedata.monthlytrend.length; i++) {
          pushTrdIns.push(mttrwholedata.monthlytrend[i].Request_Priority + " -> " + mttrwholedata
            .monthlytrend[i].insights)
        }
        insArr = pushTrdIns.join("\r\n")
      }
      var fileName = this.widgetControl + '_Insights.txt'
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    convert2ddhhmm(minutesValue, suffix) {
      if (suffix != "") {
        if (suffix.toUpperCase() == "H") {
          minutesValue = minutesValue * 60;
        } else if (suffix.toUpperCase() == "D") {
          minutesValue = minutesValue * 60 * 8;
        }
        var hours = Math.floor(minutesValue / 60);
        var minutes = Math.round((minutesValue % 60), 2);
        var days = 0;
        if (hours > 24) {
          days = Math.floor(hours / 24);
          hours = Math.floor(hours % 24);
        }
        var returnVal = '';
        if (days != 0) {
          returnVal += days + 'd ';
        }
        if (hours != 0) {
          returnVal += hours + 'h ';
        }
        if (minutes != 0) {
          returnVal += minutes + 'm ';
        }
      } else {
        returnVal = minutesValue;
      }
      if (returnVal == 0) {
        returnVal = '-'
      }
      return returnVal;
    },
    drawsparkChrts(data, hasAdherence) {
      var sparklineC
      var tooltipArr = data[0].Mttr_Month;
      var tooptipConv = this.convert2ddhhmm
      try {
        if (hasAdherence) {
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let domEle = document.getElementById("MTTXA" + index);
            let elWidth = document.getElementById("MTTXA" + index).offsetWidth;
            sparklineC = new Sparkline(domEle, {
              lineColor: "#1e7895",
              minValue: 0,
              endColor: "#777",
              maxColor: "#11a8ab",
              width: elWidth,
              minColor: "red",
              fillLighten: 0.75,
              tooltip: function (value, index, collection) {
                return tooltipArr[index] + ': ' + value + "%";
              }
            });
            sparklineC.draw(element.spkLine_sla);
          }
        }
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let elWidthNew = document.getElementById("MTTXV" + index).offsetWidth;
          sparklineC = new Sparkline(document.getElementById("MTTXV" + index), {
            lineColor: "#1e7895",
            minValue: 0,
            endColor: "#777",
            maxColor: "red",
            minColor: "#11a8ab",
            fillLighten: 0.75,
            width: elWidthNew,
            tooltip: function (value, index, collection) {
              return tooltipArr[index] + ': ' + tooptipConv(value, 'M');
            }
          });
          sparklineC.draw(element.spkLine_mttr);
        }
      } catch (error) {
        // console.log(error)
      }
    },
    swapCharts() {
      this.isdrawTrend = !this.isdrawTrend;
      this.drawBubbleChart()
    },
    drawBubbleChart() {
      var emit = this.$emit
      var scatterChartData = {}
      let chartDomMTT = document.getElementById('mttrBC');
      if(chartDomMTT == null) return;
      if (chartDomMTT != null && chartDomMTT != undefined) {
        chartDomMTT.style.height = "400px"
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myMTTChart = echarts.init(chartDomMTT);
        }
        if (this.isdrawTrend) {
          let seriesArr = []
          for (let index = 0; index < mttrwholedata.monthlytrend.length; index++) {
            const element = mttrwholedata.monthlytrend[index];
            let label1 = this.getwgtCond == 5 ? " Hops" : " Reopened"
            seriesArr.push({
              name: element.Request_Priority + " " + label1,
              type: 'bar',
              data: element.count,
              itemStyle: {
                borderRadius: 2,
                color: this.myColorArray[index % 11],
                borderColor: this.myBorderArray[index % 11],
                borderWidth: 1,
                opacity: 1
              }
            },)
          }
          let option = {
            tooltip: {
              confine: true,
              trigger: 'axis',
            },
            legend: {
              width: document.getElementById('mttrsnap').clientWidth - 150,
              left: 50,
              type: 'scroll',
              textStyle: {
                color: "#777"
              }
            },
            grid: {
              top: 60,
              left: 60,
              right: 60,
              bottom: 30,
            },
            xAxis: [{
              type: 'category',
              data: mttrwholedata.Labels,
              splitArea: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10
              },
            }],
            yAxis: [{
              type: 'value',
              nameTextStyle: {
                fontSize: 10,
                color: "#777"
              },
              splitArea: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10
              },
            },],
            series: seriesArr
          };
          myMTTChart.setOption(option, {
            notMerge: true
          });
          myMTTChart.on('click', function (params) {
            let clickitem = {},
              selectedWord;
            let label = params.seriesName;
            if (label.search("Reopened") > 0) {
              selectedWord = label.substring(0, label.search("Reopened")).trim()
              clickitem = {
                "currpass": params.seriesName + "~" + params.name,
                "filterop": "ReopenedMonth"
              }
            } else {
              selectedWord = label.substring(0, label.search("Hops")).trim()
              clickitem = {
                "currpass": params.seriesName + "~" + params.name,
                "filterop": "ReassignedMonth"
              }
            }
            emit("getKDrill", clickitem)
          })
        } else {
          scatterChartData.datasets = []
          var tempToCnt = 0,
            tempRVal
          for (let i = 0; i < mttrwholedata.mttrdata.length; i++) {
            tempToCnt += mttrwholedata.mttrdata[i].PriorityCount
          }
          for (let i = 0; i < mttrwholedata.mttrdata.length; i++) {
            tempRVal = mttrwholedata.mttrdata[i].PriorityCount / tempToCnt * 100 > 10 ? mttrwholedata
              .mttrdata[
              i]
              .PriorityCount / tempToCnt * 100 : 10
            if (this.getwgtCond == 4) {
              scatterChartData.datasets.push({
                name: mttrwholedata.mttrdata[i].Request_Priority + ' Reopened',
                data: [
                  [mttrwholedata.mttrdata[i].Request_Priority, mttrwholedata.mttrdata[
                    i]
                    .Mttr,
                  mttrwholedata.mttrdata[i].PriorityCount,
                  Math.round(tempRVal)
                  ]
                ],
                type: 'scatter',
                symbolSize: function (data) {
                  return data[3];
                },
                emphasis: {
                  focus: 'self'
                },
              })
            } else {
              scatterChartData.datasets.push({
                name: mttrwholedata.mttrdata[i].Request_Priority + ' Hops',
                data: [
                  [mttrwholedata.mttrdata[i].Request_Priority, mttrwholedata.mttrdata[
                    i]
                    .Mttr,
                  mttrwholedata.mttrdata[i].PriorityCount,
                  Math.round(tempRVal)
                  ]
                ],
                type: 'scatter',
                symbolSize: function (data) {
                  return data[3];
                },
                emphasis: {
                  focus: 'self'
                },
              })
            }
          }
          let option = {
            legend: {
              width: document.getElementById('mttrsnap').clientWidth - 150,
              left: 50,
              type: 'scroll',
              textStyle: {
                color: "#777"
              }
            },
            tooltip: {
              confine: true,
              formatter: (params) => {
                return "There are " + params.value[2] + " ticket(s) which has " + params
                  .seriesName +
                  " and MTTR is " + convert2ddhhmm(params.value[1], "M");
              },
              position: function (pos, params, dom, rect, size) {
                var obj = {
                  top: pos[1]
                };
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
                return obj;
              }
            },
            xAxis: {
              type: 'value',
              scale: true,
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10
              }
            },
            yAxis: {
              type: 'value',
              scale: true,
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10,
                formatter: function (value, index) {
                  return convert2ddhhmm(value, "M");
                }
              },
            },
            grid: {
              top: 60,
              left: 60,
              right: 60,
              bottom: 30,
            },
            series: scatterChartData.datasets
          };
          option && myMTTChart.setOption(option, {
            notMerge: true
          });
          myMTTChart.on('click', function (params) {
            let clickitem = {},
              selectedWord;
            let label = params.seriesName;
            if (label.search("Reopened") > 0) {
              selectedWord = label.substring(0, label.search("Reopened")).trim()
              clickitem = {
                "currpass": selectedWord,
                "filterop": "Reopen"
              }
            } else {
              selectedWord = label.substring(0, label.search("Hops")).trim()
              clickitem = {
                "currpass": selectedWord,
                "filterop": "Hop"
              }
            }
            emit("getKDrill", clickitem)
          })
        }
      }
    },
    renderTrend(priorOp) {
      var monthlycount
      var monthlycountinmins
      priorOp = priorOp[0]
      this.mttrinsight = []
      try {
        for (var i = 0; i < mttrwholedata.monthlytrend.length; i++) {
          if (priorOp.Request_Priority == mttrwholedata.monthlytrend[i].Request_Priority) {
            monthlycountinmins = mttrwholedata.monthlytrend[i].trend
            this.mttrinsight = mttrwholedata.monthlytrend[i].insights
            monthlycount = mttrwholedata.monthlytrend[i].count
            break
          }
        }
        let chartDomMTTR = document.getElementById('mttrTrend');
        if(chartDomMTTR == null) return;
        if (chartDomMTTR != null && chartDomMTTR != undefined) {
          chartDomMTTR.style.height = "297px"
          if (this.isChartRedraw) {
            this.isChartRedraw = false;
            myMTTChart = echarts.init(chartDomMTTR);
          }
          let optionMTTR = {
            tooltip: {
              confine: true,
              formatter: (params) => {
                return params.name + ": " + monthlycount[params.dataIndex] +
                  " ticket(s) which takes " + convert2ddhhmm(monthlycountinmins[params
                    .dataIndex],
                    "M");
              },
            },
            legend: {
              width: document.getElementById('mttrsnap').clientWidth - 150,
              left: 50,
              type: 'scroll',
              textStyle: {
                color: "#777"
              }
            },
            grid: {
              top: 60,
              left: 60,
              right: 60,
              bottom: 30,
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: mttrwholedata.Labels,
              splitArea: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10
              },
            }],
            yAxis: [{
              type: 'value',
              name: '# Tickets',
              nameTextStyle: {
                fontSize: 10,
                color: "#777"
              },
              splitArea: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10
              },
            },
            {
              type: 'value',
              name: 'Time taken',
              nameTextStyle: {
                fontSize: 10,
                color: "#777"
              },
              splitArea: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              },
              axisLabel: {
                color: "#777",
                fontSize: 10,
                formatter: function (value, index) {
                  return convert2ddhhmm(value, "M");
                }
              },
            }
            ],
            series: [{
              type: 'bar',
              itemStyle: {
                borderRadius: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(30,120,149,0.75)'
                },
                {
                  offset: 1,
                  color: 'rgba(30,120,149,0.25)'
                }
                ]),
                borderColor: '#1e7895',
                borderWidth: 1,
              },
              name: 'Ticket Count',
              data: monthlycount,
            },
            {
              type: 'line',
              symbolSize: 8,
              symbol: 'circle',
              yAxisIndex: 1,
              itemStyle: {
                color: "#009000"
              },
              name: 'Avg Time Taken(in mins)',
              data: monthlycountinmins,
            }
            ]
          };
          myMTTChart.setOption(optionMTTR);
        }
      } catch (error) {
        // console.log(error)
      }
    },
    mttrswap(val) {
      if (val == 0) {
        this.shwMttr = true
        this.isMttrTrend = false
        this.mttrinsight = mttrwholedata.insights
        for (let i = 0; i < this.mttrinsight.length; i++) {
          this.mttrinsight[i] = this.mttrinsight[i].replace(/\|/g, '').replace(/~/g, '')
        }
        if (this.mttrinsight.length == 0) {
          this.IsMTInsErr = true
        }
      } else {
        this.shwMttr = false
        this.isMttrTrend = true
        this.mttrinsight = mttrwholedata.insights
        for (let i = 0; i < this.mttrinsight.length; i++) {
          this.mttrinsight[i] = this.mttrinsight[i].replace(/\|/g, '').replace(/~/g, '')
        }
        if (this.mttrinsight.length == 0) {
          this.IsMTInsErr = true
        }
      }
    },
    onReMttr(params) {
      this.mttrReApi = params.api
      this.gridColumnApi = params.columnApi
      this.mttrReApi.setRowData(mttrwholedata.mttrdata)
      params.api.sizeColumnsToFit();
    },
    onTickets(params) {
      let clickitem
      if (this.widgetControl == "Resolution Time by Priority") {
        clickitem = {
          "currpass": params,
          "filterop": "Resolution"
        }
      } else {
        clickitem = {
          "currpass": params,
          "filterop": "Response"
        }
      }
      this.$emit("getKDrill", clickitem)
    },
    getMTTR(tabval) {
      this.IsInsightMttr = false
      this.IsMttrdata = false
      this.isMttrTrend = false
      this.IsMttrErr = false
      this.IsMTInsErr = false
      this.shwMttr = false
      this.myBubbleShow = false
      this.isLoadmttr = false
      this.tbl_mttr = "MTTR"
      var mttrHdr = "Request_Priority"
      switch (tabval) {
        case 0:
          mttrHdr = "Request_Priority"
          this.widgetControl = "Resolution Time by Priority"
          break
        case 2:
          this.tbl_mttr = "MTTA"
          mttrHdr = "Request_Priority"
          this.widgetControl = "Acknowledgement Time by Priority"
          break
        case 3:
          mttrHdr = "Request_Priority"
          this.widgetControl = "Resolution Time by Priority"
          break
        case 4:
          this.myBubbleShow = true
          mttrHdr = "Reopen Count"
          this.widgetControl = "Resolution Time by Reopen Count"
          break
        case 5:
          this.myBubbleShow = true
          mttrHdr = "Reassignment Count"
          this.widgetControl = "Resolution Time by Reassignment Count"
          break
        default:
          break
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/mttrtrendviews?Cond=' + tabval + "&asg_id=" + this
        .asgId, {
        "get_prior": this.getPins.get_prior,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              mttrwholedata = response.data
              this.mttrdata = mttrwholedata.mttrdata
              if (this.mttrdata.length != 0 && this.mttrdata[0].slaadherence == '-') {
                this.isslaadherence = false
              } else {
                this.isslaadherence = true
              }
              this.mttrinsight = []
              this.mttrinsight = mttrwholedata.insights;
              for (var i = 0; i < this.mttrinsight.length; i++) {
                this.mttrinsight[i] = this.mttrinsight[i].replace(/\|/g, '').replace(/~/g, '');
              }
              this.genrateExplainLink()
              if (tabval >= 4) {
                if (this.isChartRedraw) {
                  try {
                    echarts.dispose(myMTTChart);
                  } catch (error) {
                    // console.log("..")
                  }
                }
                this.drawBubbleChart(mttrwholedata)
                if (this.isslaadherence) {
                  this.mttrcolsDefs = [{
                    headerName: mttrHdr,
                    field: "Request_Priority",
                    sortable: true,
                    suppressSizeToFit: true,
                    cellClass: 'text-start'
                  },
                  {
                    headerName: "SLA Adherence",
                    field: "slaadherence",
                    valueGetter: this.percGetter,
                    sortable: true,
                    suppressSizeToFit: true,
                    cellClass: 'text-end'
                  },
                  {
                    headerName: "MTTR",
                    field: "Mttr",
                    valueGetter: this.daysGetter,
                    sortable: true,
                    suppressSizeToFit: true,
                    cellClass: 'text-end'
                  },
                  {
                    headerName: "# Tickets",
                    field: "PriorityCount",
                    sortable: true,
                    suppressSizeToFit: true,
                    type: 'numericColumn',
                    cellClass: 'text-end'
                  }
                  ]
                } else {
                  this.mttrcolsDefs = [{
                    headerName: mttrHdr,
                    field: "Request_Priority",
                    sortable: true,
                    suppressSizeToFit: true,
                    cellClass: 'text-start'
                  },
                  {
                    headerName: "MTTR",
                    field: "Mttr",
                    valueGetter: this.daysGetter,
                    sortable: true,
                    suppressSizeToFit: true,
                    cellClass: 'text-end'
                  },
                  {
                    headerName: "# Tickets",
                    field: "PriorityCount",
                    sortable: true,
                    suppressSizeToFit: true,
                    type: 'numericColumn',
                    cellClass: 'text-end'
                  }
                  ]
                }
              } else {
                try {
                  this.isMttrTrend = true
                  if (this.getPins.get_prior == "All") {
                    this.mttrswap(0)
                  } else {
                    this.Reqpriors = mttrwholedata.Reqdrops;
                    var Montrend = [mttrwholedata.monthlytrend[0]];
                    this.mttrswap(1)
                    setTimeout(() => {
                      this.isChartRedraw = true;
                      this.renderTrend(Montrend);
                    }, 100);
                  }
                  setTimeout(() => {
                    this.drawsparkChrts(this.mttrdata, this.isslaadherence)
                  }, 100);
                } catch (error) {
                  // console.log(error)
                }
              }
            } else if (response.data == "Nodata") {
              this.IsMttrdata = true
            } else {
              this.isMttrTrend = true
              this.IsMttrErr = true
              this.shwMttr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in MTTR. Try after sometime!'
              })
            }
            this.isLoadmttr = true
            this.isMTTRTablelLoaded = true;
          }
        }).catch((response) => {
          this.isMttrTrend = true
          this.IsMttrErr = true
          this.shwMttr = true
          this.isLoadmttr = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in MTTR. Try after sometime!'
            })
          }
        })
    },
    percGetter(params) {
      return params.data.slaadherence + '%'
    },
    daysGetter(params) {
      var pier = params.data.Mttr
      pier = Math.round(pier);
      var hours = Math.floor(pier / 60);
      var minutes = pier % 60;
      var timeret = "";
      if (hours > 0) {
        if (hours < 24) {
          timeret += hours + "h ";
        } else {
          var days = Math.floor(hours / 24);
          hours = hours - (days * 24);
          timeret += days + "d " + hours + "h ";
        }
      }
      if (minutes > 0) {
        timeret += minutes + "m ";
      }
      if (timeret == "") {
        timeret = "< 1min"
      }
      return timeret
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getMTTR(this.getwgtCond)
    this.isChartRedraw = true
    this.myColorArray = [new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(253, 55, 56, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(253, 55, 56, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(247, 99, 12, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(247, 99, 12, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 185, 0, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(255, 185, 0, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 192, 192, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(75, 192, 192, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 162, 235, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(54, 162, 235, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(136,23,152, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(136,23,152, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(168, 192, 255, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(168, 192, 255, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 216, 155, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(255, 216, 155, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(178, 159, 148, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(178, 159, 148, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 191, 54, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(54, 191, 54, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 19, 79, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(75, 19, 79, 0.25)'
    }]),
    ]
    this.myBorderArray = ['rgba(253, 55, 56, 0.9)',
      'rgba(247, 99, 12, 0.9)',
      'rgba(255, 185, 0, 0.9)',
      'rgba(75, 192, 192, 0.9)',
      'rgba(54, 162, 235, 0.9)',
      'rgba(136,23,152, 0.9)',
      'rgba(168, 192, 255,0.9)',
      'rgba(255, 216, 155,0.9)',
      'rgba(178, 159, 148, 0.9)',
      'rgba(54, 191,54,0.9)',
      'rgba(75, 19, 79, 0.75)'
    ]
    window.addEventListener("resize", reportWindowSizeMTT);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeMTT);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    },
    hrstoDays(mttr) {
      var pier = Math.round(pier);
      var hours = Math.floor(pier / 60);
      var minutes = pier % 60;
      var timeret = "";
      if (hours > 0) {
        if (hours < 24) {
          timeret += hours + "h ";
        } else {
          var days = Math.floor(hours / 24);
          hours = hours - (days * 24);
          timeret += days + "d " + hours + "h ";
        }
      }
      if (minutes > 0) {
        timeret += minutes + "m ";
      }
      if (timeret == "") {
        timeret = "< 1min"
      }
      return timeret
    },
    getgradRed() {
      return this.$store.getters.getgradRed
    }
  },
  watch: {
    getPins() {
      this.getMTTR(this.getwgtCond)
    },
    getpass() {
      this.getMTTR(this.getwgtCond)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chartHeightControlMTTR {
  height: 297px !important;
}

.tblSection {
  width: 100%;
  height: 390px;
  overflow-y: auto;
}

.sltbl {
  height: 350px;
  overflow-y: auto;
}

.ftsize {
  font-size: 120%;
}

.table-striped tbody td {
  line-height: 40px;
  height: 60px;
}
</style>